export const environment = {
    production: true,
    apiBaseUrl: 'https://versuspay-api-staging.versusfintech.com/api/v1',
    qrcodeUrl:'https://versuspay-staging.versusfintech.com/qrcode/payment',
    qrCodeSchool:'https://versuspay-staging.versusfintech.com/school/payment',
    frontBaseUrl:'https://versuspay-staging.versusfintech.com',
    isVersusPay: true,
    MIN_AMOUNT_SCHOOL_PAYMENT: 5,
    codeParent: 'versusci',
    codeCountry: 'CI',
    
    partnerTypes: [
        {
            code: 'MERCHANT',
            libelle:'Marchand'
        },
        {
            code: 'PROVIDER',
            libelle:'Fournisseur moyen de paiement'
        }
    ]
};
